import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import './Galeria.css';
import img1 from './rest/img1.jpg';
import img2 from './rest/img2.jpg';
import img3 from './rest/img3.jpg';
 
const galeriaRest = () => {
  const handleOnDragStart = e => e.preventDefault()
  return (
    <AliceCarousel className="galeria"
        mouseDragEnabled
        autoPlay={true}
        duration={1000}
        autoPlayInterval={5000}
        dotsDisabled={true}
        buttonsDisabled={true}
        stopAutoPlayOnHover={false}
   >
      <img src={img1} onDragStart={handleOnDragStart} className="gal-img" />
      <img src={img2} onDragStart={handleOnDragStart} className="gal-img" />
      <img src={img3} onDragStart={handleOnDragStart} className="gal-img" />
   </AliceCarousel>
  )
}
export default galeriaRest;


// WEBPACK FOOTER //
// ./src/Galeria/Galeria-Rest.js